<template>
    <v-container fluid class="pa-0">
        <h1 style="margin: 20px">
            {{ user.email }}
        </h1>

        <v-card style="margin: 20px; padding: 20px">
            <v-row no-gutters>
                <v-col sm="6"> Session expires: {{ sessionExpiresAt }} </v-col>
                <v-col sm="2">
                    <v-btn @click="refreshSession" color="primary"> Refresh Session </v-btn>
                </v-col>
                <v-col sm="2">
                    <v-btn @click="logout" color="error"> Logout </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card style="margin: 20px; padding: 20px">
            <v-row no-gutters>
                <v-col sm="2">
                    <h3>Group</h3>
                </v-col>
                <v-col sm="2">
                    <h3>Role</h3>
                </v-col>
                <v-col sm="8">
                    <h3>Permissions</h3>
                </v-col>
            </v-row>

            <hr />
            <p />

            <div v-for="(group, index) in user.groups" :key="index">
                <v-row>
                    <v-col sm="2">
                        <div class="group">
                            <b>{{ group.name }}</b>
                        </div>
                    </v-col>
                    <v-col sm="2">
                        <div class="role">
                            {{ group.role.name }}
                        </div>
                    </v-col>
                    <v-col sm="8">
                        <div v-for="(permission, index) in group.role.permissions" :key="index">
                            {{ permission.resource }}:{{ permission.action }}
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-card style="margin: 20px; padding: 20px">
            <v-row no-gutters>
                <v-col sm="10"> <b>Investigator:</b> {{ user.investigator || "N/A" }} </v-col>
            </v-row>
        </v-card>

        <v-card style="margin: 20px; padding: 20px">
            <v-row no-gutters>
                <v-col sm="10">
                    <h3>
                        Ignore Benchling Teams for Source IDs?
                        {{ user.ignoreBenchlingTeam ? "Yes" : "No" }}
                    </h3>
                    <p v-if="user.ignoreBenchlingTeam">
                        <span v-if="user.benchlingUserData">
                            The source IDs associated with your account come solely from the
                            Projects associated to the Groups you are a member of, not from your
                            Benchling account.
                        </span>
                        <span v-else>
                            The source IDs associated with your account come solely from the
                            Projects associated to the Groups you are a member of.
                        </span>
                    </p>
                    <p v-else>
                        The source IDs associated with your account come from both the Projects
                        associated to the Groups you are a member of, <i>and</i> the Projects
                        associated to your Benchling account.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col sm="10" v-if="user.benchlingUserData">
                    <h3>Source IDs from your Benchling user account</h3>
                    <div
                        class="source-id"
                        v-for="(sourceId, index) in user.benchlingUserData.sourceIds"
                        :key="index"
                    >
                        {{ sourceId }}
                    </div>
                    <h3>Source IDs from Projects associated to your Groups</h3>
                    <div
                        class="source-id"
                        v-for="(sourceId, index) in groupProjectSourceIds"
                        :key="index"
                    >
                        {{ sourceId }}
                    </div>
                    <div class="source-id" v-if="groupProjectSourceIds.length === 0">
                        No source IDs from Projects associated to your Groups
                    </div>
                </v-col>
                <v-col sm="10" v-else>
                    <h3>Source IDs from Projects associated to your Groups</h3>
                    <div class="source-id" v-for="(sourceId, index) in user.sourceIds" :key="index">
                        {{ sourceId }}
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>
<script>
import { defineComponent } from "vue";

import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "ProfileInfo",

    computed: {
        ...mapGetters(["getAuthUser", "sessionExpiresAt"]),
    },

    async mounted() {
        this.user = this.getAuthUser;
        const benchlingUserData = this.user.benchlingUserData;
        const benchlingUserSourceIds = benchlingUserData ? benchlingUserData.sourceIds : [];
        this.groupProjectSourceIds = this.user.sourceIds.filter((sourceId) => {
            return !benchlingUserSourceIds.includes(sourceId);
        });
    },

    methods: {
        ...mapActions(["refreshSession", "logout"]),
    },

    data() {
        return {
            groupProjectSourceIds: [],
            user: {
                name: "foo",
            },
        };
    },
});
</script>

<style>
.source-id {
    background-color: #f0f0f0;
    margin: 3px;
    display: inline-block;
    width: fit-content;
    padding: 3px;
    font-family:
        droid sans mono,
        consolas,
        monospace,
        courier new,
        courier,
        sans-serif;
    font-size: 0.8em;
}
</style>
